export function buildNameInitials(fullName: string): string {
  const nameParts = fullName
    .trim()
    .split(/\s+/)
    .filter(function keepNonEmpty(part) {
      return part.length > 0;
    });

  const firstPart = nameParts[0];
  if (firstPart === undefined) {
    return '?';
  }
  if (nameParts.length === 1) {
    return firstPart.charAt(0).toUpperCase();
  }
  const lastPart = nameParts[nameParts.length - 1];
  const lastInitial = lastPart === undefined ? '' : lastPart.charAt(0);
  return (firstPart.charAt(0) + lastInitial).toUpperCase();
}
